import { usePolicyEvaluate } from 'components/policy-loader/policy-loader';
import { ChangeReservationDurationMode } from 'pages/storage-unit-detail/components/actions/change-reservation-duration/change-reservation-duration';

// Dual-permission transition. The legacy OPA action `shortenReservation`
// stays as a fallback until the OPA bundle that ships
// `changeReservationDuration` is deployed to dev, test and prod.
//
// Cleanup checklist when that happens:
//   1. delete `shortenReservation` from src/types/policies-types.ts
//   2. drop the `canShortenReservation` branch below and the `'shortenOnly'`
//      member of ChangeReservationDurationMode
//   3. remove the legacy i18n keys (Button.UpdateReservationDuration,
//      Page.StorageUnit.Actions.UpdateReservationDuration.Heading/Success/Error)
export const useChangeReservationDurationMode = (
  // The parcel is protected by an unverified recipient release code (UPS EPRA). Shortening the window
  // sends it to collection, which releases it without the code ever being entered - so on such a parcel
  // the dedicated role decides, not the usual duration permissions. The gateway enforces the same rule.
  isTwoFactorPending = false
): ChangeReservationDurationMode | null => {
  const canManageTwoFactorReservation = usePolicyEvaluate(
    'manageTwoFactorReservation',
    'maintenance'
  );
  const canChangeReservationDuration = usePolicyEvaluate(
    'changeReservationDuration',
    'maintenance'
  );
  const canShortenReservation = usePolicyEvaluate(
    'shortenReservation',
    'maintenance'
  );

  if (isTwoFactorPending) {
    return canManageTwoFactorReservation ? 'bidirectional' : null;
  }

  if (canChangeReservationDuration) return 'bidirectional';
  if (canShortenReservation) return 'shortenOnly';
  return null;
};
